// extracted by mini-css-extract-plugin
export default {"displaySuccessText":"home_displaySuccessText__8AzSs","iframeText":"home_iframeText__5VSCn","flexImage":"home_flexImage__jDv5i","logokhunthong":"home_logokhunthong__4VRK0"};